import React from 'react'

import { Button, Icon, ArrowRight, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, arrayOf, shape } from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import CollectionCard from './Components/CollectionCard'

function CollectionHubHero({
  title = 'Discover Curated 3D Model Collections',
  subtitle = 'Explore our curated collections—carefully selected groups of 3D models ' +
  'designed to help you find assets faster.',
  highlightedCollections = EMPTY_ARRAY,
  collectionType = 'cg',
}) {
  const isPrint = collectionType === 'print'
  const heroHref = isPrint ? '/3d-print-collections' : '/3d-collections'

  return (
    <section
      className={classnames('collection-hub-hero', isPrint && 'collection-hub-hero--print')}
      aria-labelledby="collection-hub-title"
    >
      <div className="collection-hub-hero__container">
        <header className="collection-hub-hero__header">
          <h1 id="collection-hub-title" className="collection-hub-hero__title">
            {title}
          </h1>
          <p className="collection-hub-hero__subtitle">{subtitle}</p>
        </header>
        <div className="collection-hub-hero__cards">
          {highlightedCollections.map((collection, index) => (
            <CollectionCard
              key={collection.id}
              {...collection}
              slot={index + 1}
              collectionType={collectionType}
            />
          ))}
        </div>
        <div className="collection-hub-hero__view-all">
          <Button
            type="secondary"
            trailIcon={<Icon svgComponent={ArrowRight} size="small" />}
            href={heroHref}
            expand
          >
            View all collections
          </Button>
        </div>
      </div>
    </section>
  )
}

CollectionHubHero.propTypes = {
  title: string,
  subtitle: string,
  highlightedCollections: arrayOf(
    shape({
      id: string,
      slug: string,
      title: string,
      description: string,
      imageUrl: string,
      href: string,
    })
  ),
  collectionType: string,
}

export default CollectionHubHero
